export function formatDate(data) {
  if (!data) return;

  const d = new Date(!Number(data) && typeof data === 'string' ? data : parseInt(data + '000'));

  if (isNaN(d.getDate())) return data;

  const day = `${withZero(d.getDate())}`;
  const month = `${withZero(d.getMonth() + 1)}`;
  const year = `${d.getFullYear()}`;

  return `${day}.${month}.${year}`;
}

function withZero(number) {
  return ('0' + number).slice(-2);
}
